/**
 * @var grecaptcha
 * @var localizedScript
 * @constructor
 */
export const SubscribeFormHandler = () => {
	const form = document.getElementById("subscribe_form");
	if (!form) return;

	form.addEventListener("submit", async (e) => {
		e.preventDefault();

		const name = form.querySelector("#subscriber_name").value.trim();
		const email = form.querySelector("#subscriber_email").value.trim();
		const nonce = form.querySelector("input[name='subscribe_nonce']").value;
		const pk = localizedScript.pk;
		const errorEl = form.querySelector(".subscribe-error-js");

		errorEl.textContent = "";

		try {
			const token = await grecaptcha.execute(pk, { action: "subscribe" });
			const res = await fetch(localizedScript.url, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
				},
				body: new URLSearchParams({
					action: "subscribe_form_action",
					subscriber_name: name,
					subscriber_email: email,
					subscribe_nonce: nonce,
					recaptcha_token: token,
				}),
			});

			const result = await res.json();

			if (!res.ok || result.success === false) {
				errorEl.textContent = result?.data?.message || "Помилка. Спробуйте ще раз.";
				return;
			}

			form.reset();
			showThankYouModal("Дякуємо за підписку!");
		} catch (error) {
			console.log(error);
			errorEl.textContent = "Помилка мережі. Спробуйте пізніше.";
		}
	});

};
const showThankYouModal = () => {
	const modal = document.getElementById('subscribe_modal');
	modal.classList.remove('hidden');

	const closeButton = document.getElementById('modal_close');
	closeButton.addEventListener('click', () => {
		modal.classList.add('hidden');
	});
	console.log("Thank you logic continues...");
};
